import { isPlainObject } from 'lodash'
import { DATA_BINDING } from '@wix/app-definition-ids'
import type { FilterExpression } from '@wix/wix-data-client-common-standalone'
import { filterResolverKey as RESOLVER_KEY } from '@wix/wix-data-client-common-standalone'

const RESOLVER_VALUE = DATA_BINDING

export const addDataBindingResolver = (filterExpression: FilterExpression) =>
  Object.assign({}, filterExpression, { [RESOLVER_KEY]: RESOLVER_VALUE })

export const shouldResolveDataBinding = (filterExpression: FilterExpression) =>
  isPlainObject(filterExpression) &&
  filterExpression[RESOLVER_KEY] === RESOLVER_VALUE
